var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 189,
    viewBox: "0 0 160 189",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0152 170.219L113.483 26.9745C114.982 24.7249 118.021 24.1166 120.271 25.6159C122.52 27.1152 123.129 30.1542 121.629 32.4038L33.1159 165.214C41.6042 166.42 50.2853 162.723 55.2186 155.29L150.044 12.408L158.201 17.8215L63.3756 160.703C54.675 173.813 37.8301 178.804 23.3925 172.549L18.0152 170.219Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8122 150.536C14.7037 157.144 21.1367 162.816 33.335 165.033L31.5837 174.665C16.8599 171.988 7.29592 164.636 2.84347 154.461C-1.50356 144.527 -0.556868 132.853 3.58855 122.11C11.8085 100.807 33.7734 80.3421 60.4218 80.3421C82.7391 80.3421 98.865 95.5138 109.032 109.486C114.187 116.571 118.02 123.624 120.563 128.89C120.628 129.024 120.691 129.157 120.755 129.289L149.325 86.4332L157.471 91.8636L118.519 150.29L115.229 141.159L115.228 141.157L115.227 141.155L115.222 141.14L115.188 141.048C115.156 140.961 115.105 140.826 115.035 140.645C114.895 140.282 114.68 139.736 114.39 139.032C113.809 137.625 112.928 135.593 111.747 133.146C109.377 128.239 105.832 121.727 101.116 115.246C91.5427 102.09 77.9632 90.132 60.4218 90.132C38.8203 90.132 19.8819 107.079 12.7221 125.634C9.17758 134.82 8.81526 143.688 11.8122 150.536Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.133 10.4146C156.837 10.4146 159.028 12.6061 159.028 15.3095L159.028 170.549L149.238 170.549L149.238 15.3095C149.238 12.6061 151.43 10.4146 154.133 10.4146Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.5604b434d467455b07fad249e367c0b9.svg";
export { ForwardRef as ReactComponent };